import React, { Component } from 'react';
import $ from 'jquery'
import * as Common from '../CommonControlls/CommonJs';
import MainLayout from '../CommonControlls/MainLayout';
import Topmenu from '../CommonControlls/Topmenubar';
import { connect } from 'react-redux'
import Table from '../CommonControlls/TableRendrer'
import { Link } from 'react-router-dom';
import AlertModal from "../CommonControlls/AlertModal";

const mapStateToProps = (store) => {
    return store
}

const mapDispatchToProps = (dispatch) => {
    return {
        ShowAlert: (Settings) => { dispatch({ type: "UpdateAlert", payload: Settings }) },
        ShowLoader: (Isloading) => { dispatch({ type: "UpdateLoader", payload: Isloading }) },
    }
}

class Administartors_List extends Component {

    constructor(props) {
        super(props);
        this.state = {

            Save: true,
            Update: true,
            Delete: true,
            View: true,

            // Table
            data: [],
            page: 1,
            sizePerPage: 15,
            TotalRecord: 0,
            loading: false,

            alertModalData: {
                title: "",
                message: "",
                First_Callback: () => { },
                Second_Callback: () => { },
                type: 1,
            },
        };
    }

    render() {

        const CellMenu = (cell, row) => {
            return (
                <div>
                    <Link to={`/Administartor_Edit/${row.id}`}><button data-toggle="tooltip" title="Edit" class="btn TableRow_btn"><i class="fa fa-pencil-square-o" aria-hidden="true"></i></button></Link>
                    <button data-toggle="tooltip" onClick={() => this.onDelete(row.id, row.role)} title="Delete" class="btn TableRow_btn"><i class="fa fa-trash-o" aria-hidden="true"></i></button>
                </div>
            )
        }

        const columns = [
            {
                dataField: 'name',
                text: 'Name',
                sort: true,
            },
            {
                dataField: 'email',
                text: 'Email',

            },
            {
                dataField: 'contact',
                text: 'Mobile',
            },
            {
                dataField: 'creationDateTime',
                text: 'Created On',
                sort: true,
                headerStyle: (colum, colIndex) => { return { minWidth: 120 } },
            },
            
            {
                dataField: '',
                text: 'Actions',
                headerStyle: (colum, colIndex) => { return { minWidth: 120 } },
                formatter: (cell, row) => { return CellMenu(cell, row) },
                csvExport: false
            }
        ];

        return (

            <div>
                <AlertModal  {...this.state.alertModalData} />
                <MainLayout />
                <div id="right-panel" class="right-panel">
                    {/* <Topmenu/>               */}
                    <Topmenu PageTitle="Administrators" isShowAddBtn={true} AddBtnLabel="Add Administartor" AddBtnLink="/Administartor_Add" />

                    <div class="content">

                        {/*<div class="PageHeader_Container">*/}
                        {/*    <h2 class="Pageheading">Ad</h2>*/}
                        {/*</div>*/}

                        <div class="card">
                            <div class="card-body">

                                {/* <div class="TableTop_Buttons">
                        <span class="TableExport_button"><i class="fa fa-download" aria-hidden="true"></i> Export</span>
                    </div> */}

                                <Table
                                    keyField="id"
                                    data={this.state.data}
                                    page={this.state.page}
                                    sizePerPage={this.state.sizePerPage}
                                    totalSize={this.state.TotalRecord}
                                    onTableChange={this.handleTableChange}
                                    isPagination={true}
                                    columns={columns}
                                    loading={this.state.loading}
                                    // RefreshTable={this.PopulateTable}
                                />

                            </div>
                        </div>

                    </div>
                </div>
            </div>

        )
    }
    componentWillMount() {
        if (this.props.UserAuthentication.AuthToken === "") {
            this.props.history.push("/Login")
        }
        // else
        // {
        //     if(this.props.UserAuthentication.UserInfo?.permissions == "All")
        //     {
        //       this.setState({
        //         Save: false,
        //         Update:false,
        //         Delete:false,
        //         View:false
        //       })
        //     }
        //     else
        //     {
        //       Common.GetUserPermissions(this.props.UserAuthentication.UserInfo?.permissions,"Roles",(lst)=>{
        //         if ( lst.indexOf("View") == -1 )
        //         {
        //             this.props.history.push("/Dashboard")
        //         }
        //         else
        //         {         
        //           for(var i = 0; i < lst.length; i++)
        //           {                           
        //             this.setState({
        //                 [lst[i]]: false
        //             })                
        //           }
        //         }
        //       })
        //     }
        // }
    }

    componentDidMount() {
        Common.AddClassToMenueLink("MenuLink_Administrator", true, "MenuParentLink_Security")
        this.PopulateTable()
    }
    handleTableChange = (type, { page, sizePerPage, filters, sortField, sortOrder, cellEdit }) => {
        if (type === "sort") {
            let result = this.state.data
            // Handle column sort
            if (sortOrder === 'asc') {
                result = result.sort((a, b) => {
                    if (a[sortField] > b[sortField]) {
                        return 1;
                    } else if (b[sortField] > a[sortField]) {
                        return -1;
                    }
                    return 0;
                });
            } else {
                result = result.sort((a, b) => {
                    if (a[sortField] > b[sortField]) {
                        return -1;
                    } else if (b[sortField] > a[sortField]) {
                        return 1;
                    }
                    return 0;
                });
            }
            return
        }
        this.setState({
            page,
            sizePerPage
        }, () => {
            this.PopulateTable()
        })

    }
    PopulateTable = () => {
        this.setState({loading: true})

        var Parameters = {
            pageSize: this.state.sizePerPage,
            pageNumber: this.state.page,
        }

        Common.Ajax(this.props.UserAuthentication.AuthToken, "Get", false, Common.APILinks.All_Users, Parameters, (resp) => {
            this.setState({ loading: false })
            if (resp.status) {
                this.setState({
                    data: resp.data,
                    TotalRecord: resp.data.length
                })
            }
            else {
                this.props.ShowAlert({ Type: 0, Msg: resp.message })
                setTimeout(function () { $("#Alertmsgbtn").click() }, 50);
            }
        },
            (error) => {

                $("#FormSearchBtn").prop('disabled', false);
                this.setState({ loading: false })
                this.props.ShowAlert({ Type: 0, Msg: "Something went wrong, please try again." })
                setTimeout(function () { $("#Alertmsgbtn").click() }, 50);
            }
        )
    }

    onDelete = (id, roleId) => {
        this.setState({
            alertModalData: {
                title: "Delete user",
                message: "Are you sure you want to delete this record.",
                First_Callback: () => { $("#Generic-modal-CloseBtn").click(); this.DeleteRecord(id, roleId) },
                Second_Callback: () => { $("#Generic-modal-CloseBtn").click() },
                type: 1,
            }
        }, () => { $("#Show_ArletModal").click() })
    }
    DeleteRecord = (id, roleId) => {
        this.props.ShowLoader({Isloading: true})
        Common.Ajax(this.props.UserAuthentication.AuthToken, "Get", false, Common.APILinks.Delete_User, {
                id: id,
                roleId: roleId
            },
            (Result) => {
                if (Result.status) {

                    this.props.ShowLoader({Isloading: false})
                    this.props.ShowAlert({Type: 1, Msg: "Deleted Successfully"})
                    this.PopulateTable()
                    setTimeout(function () {
                        $("#Alertmsgbtn").click()
                    }, 50);
                    $("#Form_CancelBtn").click()

                } else {
                    this.props.ShowLoader({Isloading: false})
                    this.props.ShowAlert({Type: 0, Msg: Result.message})
                    setTimeout(function () {
                        $("#Alertmsgbtn").click()
                    }, 50);
                }
            },
            (error) => {
                this.props.ShowLoader({Isloading: false})
                this.props.ShowAlert({Type: 0, Msg: "Something went wronge, please try again."})
                setTimeout(function () {
                    $("#Alertmsgbtn").click()
                }, 50);
            })
    }

}

export default connect(mapStateToProps, mapDispatchToProps)(Administartors_List);
